/** @module csi/breadcrumb/RevisionDropDownButton */
define([
	"dojo/_base/declare",
	"dijit/form/DropDownButton",
	"dijit/MenuItem",
	"dijit/MenuSeparator",
	"csi/_base/underscore",
	"csi/action",
	"csi/locale",
	"csi/reflection",
	"csi/widget/DropDownMenu",
	"csi/xml"
], function(declare,DropDownButton,MenuItem,MenuSeparator,_,csiAction,locale,reflection,DropDownMenu,xml) {

	var ACTION_REVISION_CURRENT = "BreadcrumbRevisionCurrent";
	var ACTION_REVISION_CURRENT_SAMPLE = "BreadcrumbRevisionCurrentSample";
	var ACTION_REVISION_LATEST = "BreadcrumbRevisionLatest";
	var ACTION_REVISION_NEXT = "BreadcrumbRevisionNext";
	var ACTION_REVISION_PREV = "BreadcrumbRevisionPrev";

	return declare(DropDownButton, {
		/** @property {Action} revisionAction - action to select explicit revision */
		revisionAction: null,

		/** @property {Action} revisionsAction - action to open popup to select any revision */
		revisionsAction: null,

		/** @property {csi.view.Widget} view - breadcrumb view */
		view: null,

		/**
		 * Initialize menu for revisions based on currently displayed master and revision.
		 */
		postCreate: function() {
			var view = this.view;
			var master = view.getViewNode();
			var revisionAction = this.revisionAction;
			var revisionsAction = this.revisionsAction;
			var revisionUrls = master.Revisions;
			var revision = view.getRevisionNode();
			var phaseRevisions = master[reflection.ATTR_PHASE_REVISIONS];
			var index = _.indexOf(master.Revisions, revision.$URL);
			var urlLatest = master.LatestRevision;
			var urlCurrent = master.CurrentRevision;
			var urlPrevious = revisionUrls[index-1];
			var urlNext = revisionUrls[index+1];
			var dropDown = new DropDownMenu();

			function add(id, url) {
				var bActive = (url == revision.$URL);

				dropDown.addChild(new MenuItem({
					"class": "csi-menu-item-with-icon",
					disabled: !xml.isValidURL(url),
					label: locale.resource(id),
					iconClass: bActive ? "csi-checked-menu-item-check" : null,
					tooltip: locale.tooltip(id),
					onClick: function() {
						csiAction.invoke(view, view.domNode, revisionAction, {actionValue: url});
					}
				}));
			}

			function divider() {
				dropDown.addChild(new MenuSeparator());
			}

			// create drop-down menu
			add(ACTION_REVISION_LATEST, urlLatest);

			if (urlCurrent != urlLatest) {
				add(ACTION_REVISION_CURRENT, urlCurrent);
			} else if (xml.isValidURL(phaseRevisions.Production)) {
				add(ACTION_REVISION_CURRENT_SAMPLE, phaseRevisions.Sample);
			}

			divider();
			add(ACTION_REVISION_PREV, urlPrevious);
			add(ACTION_REVISION_NEXT, urlNext);
			divider();

			dropDown.addChild(new MenuItem({
				"class": "csi-menu-item-with-icon",
				label: locale.resource(revisionsAction.getId()),
				tooltip: locale.tooltip(revisionsAction.getId()),
				onClick: function() {
					csiAction.invoke(view, view.domNode, revisionsAction);
				}
			}));

			// configure button
			this.set("label", revision.$Name);
			this.set("dropDown", dropDown);
			this.inherited(arguments);
		},
		
		/**
		 * Add localized prefix to revision name 
		 */
		_setLabelAttr: function(content) {
			content = _.escape(locale.resource("RevisionTitle", [content]));
			this.inherited(arguments, [content]);
		}
	});
});